<style lang="less">
@media only screen and (max-height: 360px) {
	.agreement{
		display: none !important;
	}
}

.agreement{
	width: 100%;
	display: -webkit-box; display:flex;
	-webkit-box-align: center; align-items: center;
	-webkit-box-pack: center; justify-content: center;
	position: fixed;
	bottom: 58px;
	font-size: 10px;
	color: #999;
	z-index: 8;
	img{
		width: 12px;
		margin-right: 6px;
	}
	.book{
		color: #c62520;
		font-weight: 600;
	}
	.tit{
		color: #dc2a2a;
		font-weight: 500;
	}
}
</style>

<template>
	<!-- Main agreement -->
	<div class="agreement">
		<img v-if="agree" src="../assets/icon_multiple.png" />
		<img v-else src="../assets/icon_multiple_disable.png" />
		<slot name="agree"></slot>
	</div>
</template>

<script>
	export default {
		data: function () {
			return {
			};
		},
		components: {
		},
		props: {
			agree: {
				type: Boolean,
				default: true
			}
		},
		mounted: function () {
		},
		methods: {

		}
	};
</script>


// WEBPACK FOOTER //
// src/components/agreement.vue